export default __webpack_public_path__ + "static/media/cloud-box.e733df94.png";